<template>
  <div>
    <div v-if="title" class="mb-3">
      <strong v-html="title" />
    </div>
    <b-table
      class="text-center bg-white score_competency_table mb-0"
      bordered
      :sticky-header="stickyHeader"
      responsive
      show-empty
      :empty-text="$lang.notRecordExist"
      :fields="fields"
      :items="items"
    >
      <template #cell(score)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
      <template #cell(score0)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
      <template #cell(score1)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
    </b-table>
  </div>
</template>
<script>
import { pathOr } from "ramda";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    stickyHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    pathOr,
    renderIconCell(value = null) {
      value = (value && value.trim()) || value;
      const data = {
        "خیلی خوب": '<strong class="text-success">خیلی خوب</strong>',
        خوب: '<strong class="text-success text_success_opacity">خوب</strong>',
        متوسط: '<strong class="text-warning" >متوسط</strong>',
        ضعیف: '<strong class="text-danger text_danger_opacity">ضعیف</strong>',
        "خیلی ضعیف": '<strong class="text-danger">خیلی ضعیف</strong>',
        ندارد: '<strong class="text-muted">ندارد</strong>',
      };
      return pathOr("", [value], data);
    },
  },
};
</script>

<style lang="scss">
.score_competency_table {
  height: 100%;
  tr {
    background-color: #fff !important;
  }
}
</style>